<div class="flx-modal" role="dialog" aria-modal="true" *ngIf="translate && addPlanForm">
    <!-- header -->
    <div class="flx-modal__header">
        <h2>Clone Maintenance Plan</h2>
        <button class="icon-btn" aria-label="Close" [pTooltip]="'Close'" (click)="modalRef.hide()" tooltipPosition="left">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>
    <div class="flx-modal__subheader">
        <h3>Create a new plan using the same configuration as the original. Update the date range and
                choose whether to copy all the data.</h3>
    </div>

    <!-- body -->
     <div class="flx-modal__body mp-body">

        <div class="mp-inline-row-box mp-row">
            <div class="mp-note-label">Cloning from:</div>
            <div class="mp-note-option me-1">{{data?.name}}</div>
        </div>

        <section class="mp-subpanel mp-row" [formGroup]="addPlanForm">
            <!-- Plan Details -->
            <div class="mp-sub-body pb-1">
                <div class="mp-subhead">
                    <div class="title mandatory">Plan Details</div>
                </div>

                <!-- Plan Name -->
                <div class="mp-plan-title-row">
                    <div>
                        <input class="mp-plan-name" type="text" formControlName="name" placeholder="Plan name" aria-label="Plan name" [(ngModel)]="cloneData.name"/>
                        <p class="mp-hint">Give your plan a name</p>
                        <div class="p-error text-10" *ngIf=" addPlanForm.controls['name'].touched && addPlanForm.controls['name'].hasError('required') ">
                            <span *ngIf="addPlanForm.controls['name'].errors?.required" id="label_AssetLocStreetReqField">{{ translate?.general.validationFE.requiredField }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- When to start the plan -->
            <div class="mp-sub-body pt-1" >
                <div class="mp-subhead">
                    <div class="title">When to start the plan</div>
                </div>

                <!-- Plan Name -->
                <div class="mp-body-bulk">

                    <div class="mp-inline-row-baseline has-end-date">
                        <label class="field-label mandatory" for="startDate">Start plan from</label>

                        <div>
                            <p-calendar [yearNavigator]="true" dateFormat="dd/mm/yy" [minDate]="tomorrow"  formControlName="startDateTime" [showIcon]="true" appendTo="body" [(ngModel)]="cloneData.startDateTime"  styleClass="cal-btn"></p-calendar>
                            <div class="p-error text-10" *ngIf=" addPlanForm.controls['startDateTime']?.touched && addPlanForm.controls['startDateTime']?.hasError('required') ">
                                <span *ngIf="addPlanForm.controls['startDateTime']?.errors?.required" id="label_AssetLocStreetReqField"> Enter a start date to proceed.</span>
                            </div>

                        </div>

                        <label class="field-label" for="endType">and end</label>

                        <div class="w-25">
                            <p-dropdown [yearNavigator]="true" class="w-100" formControlName="endOption" [options]="endTimeOptions" [(ngModel)]="cloneData.endOption" optionLabel="label" optionValue="value" [placeholder]="translate?.general?.messages?.none" (onChange)="changeEndOption($event)"
                            #endDd></p-dropdown>
                            <div class="p-error text-10" *ngIf="addPlanForm.controls['endOption']?.touched && addPlanForm.controls['endOption']?.hasError('required') ">
                                <span *ngIf="addPlanForm.controls['endOption']?.errors?.required" id="label_AssetLocStreetReqField">{{ translate?.general.validationFE.requiredField
                                    }}</span>
                            </div>
                        </div>
                        <div *ngIf="cloneData.endOption != 'NEVER'">
                            <p-calendar dateFormat="dd/mm/yy" [minDate]="minDateForEndDate" formControlName="endDateTime" [showIcon]="true" appendTo="body" [(ngModel)]="cloneData.endDateTime"  styleClass="cal-btn"></p-calendar>
                            <div class="p-error text-10" *ngIf=" addPlanForm.controls['endDateTime']?.touched && addPlanForm.controls['endDateTime']?.hasError('required') ">
                                <span *ngIf="addPlanForm.controls['endDateTime']?.errors?.required" id="label_AssetLocStreetReqField">{{ translate?.general.validationFE.requiredField
                                    }}</span>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>

        <!-- Clone linked assets -->
        <section class="mp-subpanel mp-row" *ngIf="data?.planType == 'ASSET'">
            <div class="mp-subhead-sub mp-subhead--inline">
                <div>
                    <div class="title">Do you want to clone the linked assets?</div>
                    <p class="sub">Create a new plan with the same assets, or start with no assets and link them later.
                    </p>
                </div>

                <!-- toggle (use whatever switch you already have; example: p-inputSwitch) -->
                <div class="mp-subhead-toggle">
                    <p-inputSwitch [(ngModel)]="cloneData.cloneAssetOrSites" value="true" ></p-inputSwitch>
                </div>
            </div>
        </section>
        <!-- Clone linked sites -->
        <section class="mp-subpanel mp-row" *ngIf="data?.planType == 'SITE'">
            <div class="mp-subhead-sub mp-subhead--inline">
                <div>
                    <div class="title">Do you want to clone the linked sites?</div>
                    <p class="sub">Create a new plan with the same sites, or start with no assets and link them later.
                    </p>
                </div>

                <!-- toggle (use whatever switch you already have; example: p-inputSwitch) -->
                <div class="mp-subhead-toggle">
                     <p-inputSwitch [(ngModel)]="cloneData.cloneAssetOrSites" value="true" ></p-inputSwitch>
                </div>
            </div>
        </section>
    </div>

     <div class="flx-modal__footer">
        <button type="button" class="custella-btn-white" (click)="modalRef.hide()">Back</button>
        <p-button styleClass="h-32" label="Save" (onClick)="onSubmitForm()" type="button"></p-button>
    </div>
</div>